import React, { useEffect, useState } from "react";

import { BranchAccountDto } from "services/organizationBranches/restModels";
import { isCompletePhone } from "shared/lib/phoneNumber";
import { Button } from "shared/ui/Button";
import { LabeledField } from "shared/ui/LabeledField";
import { Modal } from "shared/ui/Modal";
import { PhoneInput } from "shared/ui/PhoneInput";

interface AccountPhoneDialogProps {
    open: boolean;
    // null — заводим новый аккаунт, иначе меняем номер существующему.
    account: BranchAccountDto | null;
    saving: boolean;
    onClose: () => void;
    onSubmit: (phoneNumber: string) => void;
}

export const AccountPhoneDialog = ({
    open,
    account,
    saving,
    onClose,
    onSubmit,
}: AccountPhoneDialogProps) => {
    const [phone, setPhone] = useState("");

    useEffect(() => {
        if (open) setPhone(account ? account.phoneNumber : "");
    }, [open, account]);

    const canSubmit = isCompletePhone(phone) && !saving;

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={account ? "Номер телефона аккаунта" : "Новый аккаунт"}
            maxWidth="xs"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose} disabled={saving}>
                        Отмена
                    </Button>
                    <Button onClick={() => onSubmit(phone)} disabled={!canSubmit}>
                        {account ? "Сохранить" : "Добавить"}
                    </Button>
                </>
            }
        >
            <LabeledField
                label="Номер телефона"
                htmlFor="accountPhoneNumber"
                hint={
                    account
                        ? "По новому номеру владелец и будет входить в кабинет."
                        : "Пароля у нового аккаунта нет — владелец входит в кабинет по SMS-коду."
                }
            >
                <PhoneInput
                    id="accountPhoneNumber"
                    value={phone}
                    onChange={setPhone}
                    disabled={saving}
                    autoFocus
                    onSubmit={() => canSubmit && onSubmit(phone)}
                />
            </LabeledField>
        </Modal>
    );
};
